<template>
    <div>
        <compFormEdit ref="validForm" :col=1  :formdata="getBase" v-model="formData" :labelWidth="120"/>
        <div class="text-right">
            <Button type="primary" @click="submit">下一步</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HttpAddReciveTemplate,HttpGetActiveValuationList } from "@/service/tasks";

    export default {
        data(){
            return {
                formData:{
                    billingChannel:0,
                },
                valuationList:[],
                
            }
        },
        created(){
            HttpGetActiveValuationList().then(res=>{
                this.valuationList = res.data.map(item=>{
                    return {
                        value:item.id,
                        label:item.name+'('+item.code+')',
                        attach:{
                            code:item.code
                        }
                    }
                })
            })
            if(this.$route.name == 'tasksPayableoffer'){
                this.formData.billingChannel = 1
            }
        },
        computed:{
            ...mapGetters('dictionary', ['getCusBillTypeList']),
            getBase(){
                return[
                    {
                        label: "费用类型",
                        tag:'Select',
                        key:'expenseCategoryType',
                        // options:this.getCusBillTypeList,
                        options: [
                            { value: 0, label: '作业费' },
                            { value: 1, label: '仓储费' },
                            { value: 3, label: '增值服务费' },
                        ],

                    },
                    {
                        label: "模板名称",
                        key: "name",
                    },
                    {
                        label: "计价方案",
                        tag:'vSelect',
                        key:'billingPlanId',
                        show:this.formData.expenseCategoryType == 0,
                        options:this.valuationList,
                        props:{
                            filterable:true,
                        }
                    },
                    {
                        label:'体积单位',
                        tag:'Select',
                        key:'unit',
                        show:this.formData.expenseCategoryType == 1,
                        options: [
                            // { value: 0, label: '未定义' },
                            { value: 1, label: '立方英尺' },
                            { value: 2, label: '立方米' },
                        ],
                    },
                    {
                        label: "备注",
                        key: "description",
                        required:false,
                    },
                ]
            }
        },
        methods:{
            async submit(){
                // 判断必填
                const valid = await this.$refs.validForm.validate()
                if(!valid) return;
                if(this.formData.expenseCategoryType == 0){
                    this.formData.billingPlanCode = this.valuationList.filter(item=>{
                        return item.value === this.formData.billingPlanId
                    })[0].attach.code;
                }
                HttpAddReciveTemplate(this.formData).then(res=>{
                    // this.$Message.success(res.message);
                    this.cancel()
                    // 跳转到编辑页面请求
                    if(this.$route.name == 'tasksPayableoffer'){
                        this.$router.push({
                            name: "tasksPayableofferUpdate",
                            params: { type: "add" },
                            query: { id: res.data.id }
                        });
                    }else{
                        this.$router.push({
                            name: "tasksReceiveofferUpdate",
                            params: { type: "add" },
                            query: { id: res.data.id }
                        });
                    }
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            },
            cancel(){
                this.$emit('on-close')
            }
        }
    }
</script>
